// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1eJLE","infoBtn":"quickbooks_infoBtn__3ENPl","formBox":"quickbooks_formBox__1lJSC","formFooter":"quickbooks_formFooter__2GYz_"};